import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot
} from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { of } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import { UserAuthService } from 'src/app/modules/auth/services/user.service';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(
        private authService: AuthService,
        private router: Router,
        private userAuthService: UserAuthService
    ) {}

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean> {
        return new Promise<boolean>(async resolve => {
            const unauthorizedUrl = '/auth/unauthorised';

            if (state.url === unauthorizedUrl) {
                this.userAuthService.loadingAuth = false;
                return resolve(true);
            }

            this.authService.isAuthenticated$
                .pipe(
                    takeUntil(this.authService.error$),
                    switchMap(authenticated => {
                        if (authenticated) {
                            return of(false);
                        } else {
                            this.userAuthService.login(state.url);
                            return of(true);
                        }
                    })
                )
                .subscribe(async (callbackOccurring: boolean) => {
                    if (!callbackOccurring) {
                        await this.userAuthService.loadUser();
                        if (
                            this.userAuthService.permissions.length == 0 &&
                            state.url !== unauthorizedUrl
                        ) {
                            this.userAuthService.loadingAuth = false;
                            return this.router.parseUrl(unauthorizedUrl);
                        }
                        this.userAuthService.loadingAuth = false;
                        return resolve(true);
                    }
                });

            this.authService.error$.subscribe(error => {
                if (error && state.url !== unauthorizedUrl) {
                    this.userAuthService.loadingAuth = false;
                    this.router.parseUrl(unauthorizedUrl);
                }
            });
        });
    }
}
